export default {"src":"/login-app/[GIT_HASH]/_next/static/media/add_circle.4e7b3f4b.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};